import { useTranslate } from "ra-core";
import { Link, useLocation } from "react-router";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { buttonVariants } from "@/components/ui/button";
import { AUTH_ERROR_PARAM, getForgotPasswordPath } from "@/lib/authCallbackUrl";

/**
 * Explains why an invite / password reset link landed on the login page
 * (`#/login?auth_error=<Supabase error_code>`, set by the auth callback
 * rewrite) instead of leaving the user on a mute login form.
 */
export const AuthLinkErrorAlert = () => {
  const location = useLocation();
  const translate = useTranslate();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get(AUTH_ERROR_PARAM);
  if (!code) {
    return null;
  }

  const isExpired = code === "otp_expired";
  return (
    <Alert variant="destructive">
      <AlertTitle>
        {isExpired
          ? translate("crm.auth.link_expired_title", {
              _: "This link has expired",
            })
          : translate("crm.auth.link_invalid_title", {
              _: "This link is not valid",
            })}
      </AlertTitle>
      <AlertDescription>
        {translate("crm.auth.link_error_details", {
          _: "Invitation and password reset links can only be used once and expire after a while. Ask an administrator for a new invitation, or request a new link with “Forgot password?”.",
        })}
        <Link
          to={getForgotPasswordPath(searchParams.get("email"))}
          className={buttonVariants({
            variant: "outline",
            className: "mt-3 w-full no-underline!",
          })}
        >
          {translate("crm.auth.request_new_link", {
            _: "Request a new link",
          })}
        </Link>
      </AlertDescription>
    </Alert>
  );
};
